<template>
  <div>
    <div class="border-bottom">
      <b-col
        md="12"
        :class="$style.reportInfoHead"
        class="mt-4 text-white text-center py-1 px-2 font-weight-bold"
        >SUMMARY OF FINDINGS</b-col
      >
    </div>
    <div class="border mb-4 ">
      <div></div>
      <div v-if="SHOW_BORROWER_INFO">
      <div v-for="(dataItem, dataInex) in BORROWER_DATA" :key="dataInex" class="m-2 bg-white border">
        <p class="font-weight-bold m-2 subHeading"
          >BORROWER DETAIL REPORT
          {{ dataItem.borrowerName ? '- ' : null }}{{ formatData(dataItem.borrowerName) | uppercase }}</p
        >
        <div v-if="SUMMARY_ERRORS.borrower[dataInex].borrowerRisk === null">
        <div v-if="displayBorrowerRisks(dataItem.followUps, dataItem.riskIndicators)">
        <div v-if="dataItem.riskIndicators.length" class="mb-1">
          <b-row
            v-for="(item, index) in dataItem.riskIndicators"
            :key="index"
            class="mx-2 baseContentFont"
          >
            <b-col md="2" class="border">{{
              formatData(item.riskIndicator)
            }}</b-col>
            <b-col
              md="1"
              class="border"
              :class="{
                    [$style.riskLow]: item.riskLevel === riskStatus.low,
                    [$style.riskLevel]: item.riskLevel === riskStatus.high,
                    [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                  }"
              >{{ formatData(item.riskLevel) }}</b-col
            >
            <b-col md="7" class="border">
              <div v-for="(items, index1) in item.riskcomments" :key="items">
                <div v-if="index1 === 0"
                  >{{ formatData(items) }}
                </div>
                <div v-else>
                  <div v-if="index1 === 1">
                      Note Log:
                    </div>
                  <div>{{ formatData(items) }}</div></div
                >
              </div>
            </b-col>


            <b-col md="1" class="border"
            :class="{
              [$style.riskLow]: item.riskDescription === riskStatus.cleared,
              [$style.riskLevel]: item.riskDescription === riskStatus.caution,
            }">{{
  formatData(item.riskDescription)
}}</b-col>

            <b-col md="1" class="border">
              <b-link @click="addupdate(item.id, item.riskDescription)"
                ><u>Update</u></b-link
              >
            </b-col>
          </b-row>
        </div>
        <NoRecordFound
          v-else
          message-required
          class="m-2"
        ></NoRecordFound>
        </div>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.borrower[dataInex].borrowerRisk"/>
        <div v-if="dataItem.followUps.length && SUMMARY_ERRORS.borrower[dataInex].borrowerRisk === null" class="pb-2">
        <div v-for="(item, index) in dataItem.followUps" :key="index">
          <b-row class="mx-2 baseContentFont">
            <b-col md="3" class="border">{{
              formatData(item.followUp)
            }}</b-col>

            <b-col md="9" class="border">{{
              formatData(item.followUpDetails)
            }}</b-col>
          </b-row>
        </div>
        </div>
        <!-- <div class="border mb-4"></div> -->
      </div>
      </div>
      <div v-if="SHOW_PROPERTY_INFO">
        <div></div>
        <div class="border m-2 bg-white">
          <p class="font-weight-bold m-2 subHeading"
            >PROPERTY DETAIL REPORT
          {{ PROPERTY_INFO_ADDRESS ? '- ' : null }}{{ formatData(PROPERTY_INFO_ADDRESS) | uppercase }}</p>
          <div v-if="SUMMARY_ERRORS.property === null">
          <div v-if="PROPERTY_INFO.length" class="pb-2">
            <b-row
              v-for="(item, index) in PROPERTY_INFO"
              :key="index"
              class="mx-2 baseContentFont"
            >
              <b-col md="2" class="border">{{
                formatData(item.riskIndicator)
              }}</b-col>
              <b-col
                md="1"
                class="border"
                :class="{
                      [$style.riskLow]: item.riskLevel === riskStatus.low,
                      [$style.riskLevel]: item.riskLevel === riskStatus.high,
                      [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                    }"
                >{{ formatData(item.riskLevel) }}</b-col
              >
              <b-col md="7" class="border">
                <div v-for="(items, index1) in item.riskcomments" :key="items">
                  <div v-if="index1 === 0" class="textSpacing"
                    >{{ formatData(items) }}
                  </div>
                  <div v-else>
                    <div v-if="index1 === 1">
                      Note Log:
                    </div>
                    <div>{{ formatData(items) }}</div>
                  </div>
                </div>
              </b-col>


              <b-col md="1" class="border"
              :class="{
                [$style.riskLow]: item.riskDescription === riskStatus.cleared,
                [$style.riskLevel]: item.riskDescription === riskStatus.caution,
              }"
                >{{ formatData(item.riskDescription) }}</b-col>
              <b-col md="1" class="border">
                <b-link @click="addupdate(item.id, item.riskDescription)"
                  ><u> Update</u></b-link
                >
              </b-col>
            </b-row>
          </div>
          <NoRecordFound
            v-else
            message-required
            class="m-2"
          ></NoRecordFound>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.property"/>
        </div>
      </div>
      <div v-if="driverInformation.participantResponses">
        <div></div>
        <div class="m-2 bg-white border">
          <p class="font-weight-bold m-2 subHeading"
            >PARTICIPANT DETAIL REPORT</p
          >
          <div v-if="SUMMARY_ERRORS.participant === null">
          <div
            v-if="driverInformation.riskIndicators !== null &&
              driverInformation.riskIndicators.length > 0
              "
            class="pb-2"
          >
            <b-row
              v-for="(item, index) in driverInformation.riskIndicators"
              :key="index"
              class="mx-2 baseContentFont"
            >
              <b-col md="2" class="border">{{
                formatData(item.riskIndicator)
              }}</b-col>
              <b-col
                md="1"
                class="border"
                :class="{
                      [$style.riskLow]: item.riskLevel === riskStatus.low,
                      [$style.riskLevel]: item.riskLevel === riskStatus.high,
                      [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                    }"
                >{{ formatData(item.riskLevel) }}</b-col
              >
              <b-col md="7" class="border">
                <div v-for="(items, index1) in item.riskcomments" :key="items">
                  <div v-if="index1 === 0" class="textSpacing"
                    >{{ formatData(items) }}
                  </div>
                  <div v-else>
                    <div v-if="index1 === 1">
                      Note Log:
                    </div>
                    <div >{{ formatData(items) }}</div>
                  </div>
                </div>
              </b-col>


              <b-col md="1" class="border"
              :class="{
                [$style.riskLow]: item.riskDescription === riskStatus.cleared,
                [$style.riskLevel]: item.riskDescription === riskStatus.caution,
              }">{{
  formatData(item.riskDescription)
}}</b-col>

              <b-col md="1" class="border">
                <b-link @click="addupdate(item.id, item.riskDescription)"
                  ><u> Update</u></b-link
                >
              </b-col>
            </b-row>
          </div>
          <NoRecordFound
            v-else
            message-required
            class="m-2"
          ></NoRecordFound>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.participant"/>
        </div>
        <div class="border"></div>
      </div>
      <div class="d-flex justify-content-between py-2">
        <div class="font-weight-bold ml-4">REMARKS</div>
        <div class="mr-4 baseContentFont"
          ><b-link @click="addcomments"><u>Add Comments</u></b-link></div
        >
      </div>
      <div
        v-for="(item, index) in propertyComments"
        :key="index"
        class="ml-4 mb-1 baseContentFont"
        >{{ item }}</div
      >
    </div>
  </div>
</template>

<script>
import constant from '@constants/constant.json'
import NoRecordFound from '@src/components/_norecord-found.vue'
import { uppercase } from "@/src/utils/filters"
import CustomMessage from '@/src/components/_custom-message.vue'
export default {
  components: { NoRecordFound, CustomMessage },
  filters: {
    uppercase
  },
  props: {
    associatedBusiness: {
      type: Array,
      default: () => [],
    },
    driverInformation: {
      type: Object,
      default: () => {},
    },
    propertyComments: {
      type: Array,
      default: () => [],
    },
    propertyInformation: {
      type: Object,
      default: () => {},
    },
    showPropertyDetails: {
      type: Boolean,
      default: false,
    },
    showBorrowerDetails: {
      type: Boolean,
      default: false,
    },
    summaryErrors: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      propertystatus: '',
      validateRecordTypes: [1, 2],
      riskStatus: constant.RiskIndicatorItems,
    }
  },
  computed: {
    BORROWER_DATA() {
      return this.associatedBusiness
    },
    SHOW_BORROWER_INFO() {
      return this.showBorrowerDetails
    },
    SHOW_PROPERTY_INFO() {
      return this.showPropertyDetails
    },
    PROPERTY_INFO_ADDRESS() {
      return this.propertyInformation !== null
        ? this.propertyInformation.propertyAddress
        : null
    },
    PROPERTY_INFO() {
      return this.propertyInformation !== null
        ? this.propertyInformation.riskResponseModel
          ? this.propertyInformation.riskResponseModel || []
          : []
        : []
    },
    SUMMARY_ERRORS() {
      return this.summaryErrors
    },
  },
  methods: {
    addcomments() {
      this.$emit('addcomments')
    },
    addupdate(id, name) {
      this.$emit('addupdated', id, name)
    },
    formatData(data) {
      return data || null
    },
    displayBorrowerRisks(followUps, risks) {
      return !(followUps.length && !risks.length)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.reportInfoHead {
  margin: auto;
  background: $color-reportHeader-bg;
}

.riskLevel {
  color: $color-status-fail;
}

.riskLow {
  color: $color-status-low;
}

.riskMedium {
  color: $color-gold-bg;
}
// .reportInfoHead {
//   letter-spacing: normal;
//   letter-spacing: 0.4em;
//   letter-spacing: 4px;
//   letter-spacing: 0.4px;
// }
</style>

<style scoped>
.subHeading,
.textSpacing {
  /* letter-spacing: normal;
  letter-spacing: 0.4em;
  letter-spacing: 4px;
  letter-spacing: 0.4px; */
}
</style>
